import { render, staticRenderFns } from "./ThanksCard.vue?vue&type=template&id=25ad5b61&"
import script from "./ThanksCard.vue?vue&type=script&lang=js&"
export * from "./ThanksCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports